<template>
  <div>
    <!--タイトル-->
    <header id="header">
    
      <Header title-image="static/images/common/logo-word.svg" can-back-flag="1"></Header>

      <div class="word-search-box">
        <div class="word-search-form-box">
          <div>
            <input id="keyword" type="text" class="search-form-input" placeholder="検索語句を入力してください" v-model='keyword' v-on:keyup='searchAction'/>
          </div>
        </div>
        <div class="word-search-nav-box2">
          <div class="box-r">
            <button class="btn btn-word" v-on:click='columnAction' val=""><img src="static/images/word/all.svg" alt="全表示"></button>
          </div>

          <div class="box-l">
            <ul class="box head-box">
              <li><button class="btn btn-word" v-on:click='columnAction' val="あ" :disabled="!hasCol1"><img :src="hasCol1 ? 'static/images/word/kana-a.svg': 'static/images/word/kana-a-disable.svg'" alt="あ"></button></li>
              <li><button class="btn btn-word" v-on:click='columnAction' val="か" :disabled="!hasCol2"><img :src="hasCol2 ? 'static/images/word/kana-ka.svg': 'static/images/word/kana-ka-disable.svg'" alt="か"></button></li>
              <li><button class="btn btn-word" v-on:click='columnAction' val="さ" :disabled="!hasCol3"><img :src="hasCol3 ? 'static/images/word/kana-sa.svg': 'static/images/word/kana-sa-disable.svg'" alt="さ"></button></li>
              <li><button class="btn btn-word" v-on:click='columnAction' val="た" :disabled="!hasCol4"><img :src="hasCol4 ? 'static/images/word/kana-ta.svg': 'static/images/word/kana-ta-disable.svg'" alt="た"></button></li>
              <li><button class="btn btn-word" v-on:click='columnAction' val="な" :disabled="!hasCol5"><img :src="hasCol5 ? 'static/images/word/kana-na.svg': 'static/images/word/kana-na-disable.svg'" alt="な"></button></li>
            </ul>
            <ul class="box">
              <li><button class="btn btn-word" v-on:click='columnAction' val="は" :disabled="!hasCol6"><img :src="hasCol6 ? 'static/images/word/kana-ha.svg': 'static/images/word/kana-ha-disable.svg'" alt="は"></button></li>
              <li><button class="btn btn-word" v-on:click='columnAction' val="ま" :disabled="!hasCol7"><img :src="hasCol7 ? 'static/images/word/kana-ma.svg': 'static/images/word/kana-ma-disable.svg'" alt="ま"></button></li>
              <li><button class="btn btn-word" v-on:click='columnAction' val="や" :disabled="!hasCol8"><img :src="hasCol8 ? 'static/images/word/kana-ya.svg': 'static/images/word/kana-ya-disable.svg'" alt="や"></button></li>
              <li><button class="btn btn-word" v-on:click='columnAction' val="ら" :disabled="!hasCol9"><img :src="hasCol9 ? 'static/images/word/kana-ra.svg': 'static/images/word/kana-ra-disable.svg'" alt="ら"></button></li>
              <li><button class="btn btn-word" v-on:click='columnAction' val="わ" :disabled="!hasCol10"><img :src="hasCol10 ? 'static/images/word/kana-wa.svg': 'static/images/word/kana-wa-disable.svg'" alt="わ"></button></li>
              <li><button class="btn btn-word" v-on:click='columnAction' val="A" :disabled="!hasCol11"><img :src="hasCol11 ? 'static/images/word/alphabet-a.svg': 'static/images/word/alphabet-a-disable.svg'" alt="A"></button></li>
            </ul>
          </div>
        </div>
      </div>
    </header>

    <div id="wrapper">
	    <div class="content">
        <div class="word-list" v-for='row in rows' v-bind:key='row.id'>
          <div class="box-l">
            <div v-show="showColumn && row.header != 'A'" v-html="row.header" style="white-space: pre;"></div>
            <div v-show="showColumn && row.header == 'A'">Ａ</div>
          </div>
          <div class="box-r">
            <ul>
              <li><a href='#' :keyword='row.value' v-on:click.prevent='linkAction' v-html="row.filter_value"></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  data: function () {
    return {
      showColumn: true
    }
  },
  mounted: function () {

    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-word")
    $("body").addClass("page-word-index")    
    cmd.adjustStyle()
    
    this.loadData()
  },
  methods: {
    ...mapActions('WordModule', {
      'prevAction': 'prevAction',
      'loadData': 'loadData',
      'search': 'search',
      'searchColumn': 'searchColumn',
      'showDetail': 'showDetail',
    }),
    searchAction (e) {
      var val = $("#keyword").val()
      if (val == "") {
        this.showColumn = true
      } else {
        this.showColumn = false
      }
      this.search(val)
    },
    columnAction (e) {
      this.showColumn = true
      var element = e.currentTarget
      var value = $(element).attr("val")
      this.searchColumn(value)
    },
    linkAction (e) {
      var element = e.currentTarget
      var keyword = element.getAttribute('keyword')
      this.showDetail(keyword)
    }
    
  },
  computed: {
    
    keyword: {
      get () {
        return this.model.keyword
      },
      set (value) {
        this.model.keyword = value
      }
    },
    ...mapGetters('WordModule', [
      'model',
      'rows',
      'hasCol1',
      'hasCol2',
      'hasCol3',
      'hasCol4',
      'hasCol5',
      'hasCol6',
      'hasCol7',
      'hasCol8',
      'hasCol9',
      'hasCol10',
      'hasCol11'
    ])
  },
  components: {
    Header
  }
}
</script>

<style scoped>
input[type=text] {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/WordList.vue